import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptyLanguageModelsProps {
  onAdd: () => void;
  canWrite: boolean;
}

export const EmptyLanguageModels = ({ onAdd, canWrite }: EmptyLanguageModelsProps) => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia>
          <img src="/assets/empty-states/language-models.webp" alt="" />
        </EmptyMedia>
        <EmptyTitle>{t('developer_tools.language_models_empty_title')}</EmptyTitle>
        <EmptyDescription>
          {t('developer_tools.language_models_empty_description')}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" onClick={onAdd} disabled={!canWrite}>
          <PlusIcon size={16} />
          {t('common.add')}
        </Button>
      </EmptyContent>
    </Empty>
  );
};
